import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

export default function Section2() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_max_static');
    const webpUrl = '/media/deltamax/pc/';
    const { EFPic } = createEFPic(webpUrl);
    return (
        <div className={`${css.section02} animation`}>
            <div className="topRow">
                <div className="left box">
                    <EFPic
                        name={['DELTA MAX_web_2.webp', 'DELTA MAX_web_2.png']}
                        alt={t.raw('second_fast_charging')}
                        aria-label={t.raw('second_fast_charging')}
                    />
                    <p className="tit" dangerouslySetInnerHTML={{ __html: t.raw('second_fast_charging') }}></p>
                </div>
                <div className="middle box">
                    <EFPic
                        name={['DELTA MAX_web_1.webp', 'DELTA MAX_web_1.png']}
                        alt={t('second_capacity')}
                        aria-label={t('second_capacity')}
                    />
                    <p className="tit">{t('second_capacity')}</p>
                    <div className="capacity">
                        <span className="num">6048</span>
                        <span className="wh">Wh</span>
                    </div>
                </div>
                <div className="right">
                    <div className="r-top box">
                        <p className="num">
                            {t('second_ac_output_value')}
                            {t('second_unit')}
                        </p>
                        <p className="tit">{t('second_ac_output')}</p>
                    </div>
                    <div className="r-bottom box">
                        <EFPic
                            name={['DELTA MAX_web_4.webp', 'DELTA MAX_web_4.png']}
                            alt={t('second_smart_generator')}
                            aria-label={t('second_smart_generator')}
                        />
                        <p className="tit">{t('second_smart_generator')}</p>
                    </div>
                </div>
            </div>
            <div className="botRow">
                <div className="left box">
                    <EFPic
                        name={['DELTA MAX_web_6.webp', 'DELTA MAX_web_6.png']}
                        alt={t('second_easy_control_app')}
                        aria-label={t('second_easy_control_app')}
                    />
                    <p className="tit">{t('second_easy_control_app')}</p>
                </div>
                <div className="middle box">
                    <EFPic
                        name={['DELTA MAX_web_5.webp', 'DELTA MAX_web_5.png']}
                        alt={t('second_safe_use_bms')}
                        aria-label={t('second_safe_use_bms')}
                    />
                    <p className="tit">{t('second_safe_use_bms')}</p>
                </div>
                <div className="right box">
                    <EFPic
                        name={['DELTA MAX_web_3.png', 'DELTA MAX_web_3.webp']}
                        alt={t('second_solar_power')}
                        aria-label={t('second_solar_power')}
                    />
                    <p className="num">
                        {t('second_solar_power_value')}
                        {t('second_unit')}
                    </p>
                    <p className="tit">{t('second_solar_power')}</p>
                </div>
            </div>
        </div>
    );
}
